<template>
  <section class="ui segment ad-entry-banner" aria-label="上位表示広告枠エントリー受付">
    <div class="ad-entry-banner__body">
      <div class="ad-entry-banner__left">
        <div class="ad-entry-banner__left-header">
          <span class="ad-entry-banner__title">上位表示広告枠エントリーのご案内</span>
          <p class="ad-entry-banner__lead">
            例年、年末に向けて多くのお申し込みをいただくため、事前申請フォームをご用意しました。申請いただいた店舗さまから優先的にご案内します。
          </p>
        </div>
        <div class="ad-entry-banner__left-content">
          <div class="ad-entry-banner__plan-summary">
            <p class="ad-entry-banner__plan-summary-title">
              上位広告枠とは
              <span
                class="ad-entry-banner__help-mark"
                data-help="グルプラガイド（メディアサイト）の上位記事への掲載、特集記事の作成、検索ページでの上位表示ができる広告プランです。"
              >?</span>
            </p>
            <a class="ad-entry-banner__detail-link" href="https://allfit.notion.site/joui-pr" target="_blank">上位表示プランの詳細を見る</a>
          </div>
          <dl class="ad-entry-banner__schedule">
            <dt>掲載期間</dt>
            <dd>3ヶ月 / 6ヶ月</dd>
          </dl>
        </div>
      </div>
      <div class="ad-entry-banner__right">
        <div class="ad-entry-banner__action">
          <p class="ad-entry-banner__notice-title">注意事項</p>
          <ul class="ad-entry-banner__notes">
            <li>申請状況により掲載枠を調整する場合があります。</li>
            <li>掲載可否・開始条件は担当より個別にご連絡します。</li>
            <li>フォーム送信のみでは契約確定になりません。</li>
          </ul>
          <a class="ui button ad-entry-banner__button" href="https://forms.gle/2VeRRqYp4xmqJ3BH8" target="_blank">エントリーフォームへ進む</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ad-entry-banner',
};
</script>

<style lang="scss" scoped>
$entry-green: #2fb7b1;
$entry-green-dark: #22938e;
$entry-green-soft: #edf9f8;

.ad-entry-banner {
  overflow: hidden;
  padding: 0 !important;
  margin: 0 0 24px !important;
  border: 1px solid #b9e0dd;
  border-left: 7px solid $entry-green;
  border-radius: 4px;
  background: #f7fcfb;
  box-shadow: 0 3px 10px rgba(47, 183, 177, .16);

  &__body {
    display: grid;
    grid-template-columns: minmax(0, 1.45fr) minmax(340px, .55fr);
    gap: 20px;
    padding: 16px 22px 20px;
    background: #f7fcfb;

    @media (max-width: 980px) {
      grid-template-columns: 1fr;
    }
  }

  &__left,
  &__right {
    border: 1px solid #cfe7e5;
    border-radius: 4px;
    background: #fff;
  }

  &__left {
    overflow: hidden;
  }

  &__left-header {
    padding: 18px 20px 14px;
    background: linear-gradient(90deg, #e7f7f6 0%, #f7fcfb 72%, #fff 100%);
    border-bottom: 1px solid #d4ebe9;
  }

  &__month {
    display: inline-block;
    width: fit-content;
    margin-bottom: 8px !important;
    padding: 4px 10px;
    border: 1px solid $entry-green-dark;
    border-radius: 4px;
    background: $entry-green-dark !important;
    color: #fff !important;
    font-size: 12px;
    font-weight: 700;
  }

  &__title {
    display: block;
    margin: 0;
    padding-left: 12px;
    border-left: 5px solid $entry-green-dark;
    color: #1f2326;
    font-size: 22px;
    font-weight: 900;
    line-height: 1.2;
  }

  &__lead {
    margin: 7px 0 0;
    color: #333;
    line-height: 1.5;
  }

  &__left-content {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(350px, 1fr);
    gap: 16px;
    padding: 16px 20px;

    @media (max-width: 980px) {
      grid-template-columns: 1fr;
    }
  }

  &__plan-summary {
    padding: 12px 14px;
    border: 1px solid #cfe7e5;
    border-radius: 4px;
    background: #fff;

    &-title {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: 0 0 8px;
      color: $entry-green-dark;
      font-weight: 800;
      line-height: 1.3;
    }
  }

  &__help-mark {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: 1px solid $entry-green-dark;
    border-radius: 50%;
    color: $entry-green-dark;
    background: #fff;
    font-size: 12px;
    font-weight: 800;
    cursor: help;

    &::after {
      content: attr(data-help);
      position: absolute;
      left: 24px;
      top: 50%;
      z-index: 2;
      display: none;
      width: 340px;
      padding: 9px 11px;
      border: 1px solid #cfe7e5;
      border-radius: 4px;
      background: #fff;
      color: #444;
      box-shadow: 0 3px 10px rgba(0, 0, 0, .12);
      font-size: 12px;
      font-weight: 500;
      line-height: 1.45;
      transform: translateY(-50%);
    }

    &:hover::after {
      display: block;
    }
  }

  &__detail-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 240px;
    height: 34px;
    margin-top: 2px;
    padding: 0 16px;
    border: 1px solid $entry-green-dark;
    border-radius: 4px;
    background: #fff;
    color: $entry-green-dark;
    font-weight: 800;
    line-height: 32px;
    text-align: center;
    text-decoration: none;

    &:hover {
      background: $entry-green-soft;
    }
  }

  &__schedule {
    display: grid;
    grid-template-columns: 82px minmax(0, 1fr);
    align-items: center;
    gap: 2px 10px;
    margin: 0;
    padding: 12px 14px 10px;
    border: 1px solid #d7d7d7;
    background: #fafafa;
    border-radius: 4px;

    dt {
      color: #555;
      font-weight: 700;
      line-height: 1.35;
    }

    dd {
      margin: 0;
      line-height: 1.35;
      white-space: nowrap;
    }
  }

  &__action {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
    padding: 18px;
  }

  &__notice-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    color: $entry-green-dark;
    font-weight: 800;

    &::before {
      content: "";
      width: 4px;
      height: 20px;
      background: $entry-green;
      border-radius: 1px;
    }
  }

  &__notes {
    margin: 0;
    padding: 12px 14px;
    border: 1px solid #cfe7e5;
    border-radius: 4px;
    background: #fff;
    color: #444;
    line-height: 1.5;
    list-style-position: inside;

    li + li {
      margin-top: 4px;
    }
  }

  &__button {
    display: block !important;
    width: 100%;
    height: 44px;
    border: 1px solid $entry-green-dark;
    border-radius: 4px;
    background: $entry-green-dark !important;
    color: #fff !important;
    font-weight: 800;
    line-height: 42px;
    text-align: center;
    text-decoration: none;
    padding: 0 !important;
  }
}
</style>
